export const PAGES_SIDEBAR_OPEN_ATTRIBUTE_NAME = "data-pages-sidebar-open"
export const PAGES_SIDEBAR_ACTIVE_CLASS_NAME = "pages-sidebar__menu-item--active"
